/**
 * Lot 3 — Wrapper de gating pour les routes /internal-partners/:partnerType.
 *
 * Comportement :
 *  - Pendant le chargement : skeleton minimal (évite un flash de redirection).
 *  - Si la route n'est pas mappée à un add-on connu : redirige vers /dashboard.
 *  - Si l'utilisateur n'a pas la base ou l'add-on : redirige vers /partner/billing
 *    avec `?missing=<slug>` afin que la page billing puisse pré-cocher la case.
 *  - Admin / staff : bypass automatique.
 */
import { Navigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useRequirePartnerAddon } from "@/hooks/useRequirePartnerAddon";

export function RequirePartnerAddon({ children }: { children: React.ReactNode }) {
  const { partnerType } = useParams<{ partnerType: string }>();
  const { loading, hasAddon, requiredAddon, bypass } =
    useRequirePartnerAddon(partnerType);

  if (loading) {
    return (
      <div className="flex min-h-[60vh] items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!requiredAddon) {
    return <Navigate to="/dashboard" replace />;
  }

  if (!hasAddon && !bypass) {
    return (
      <Navigate
        to={`/partner/billing?missing=${encodeURIComponent(requiredAddon)}`}
        replace
      />
    );
  }

  return <>{children}</>;
}
